module.exports = __webpack_public_path__ + "img/morning_study1_sm.f74fe8a6.png";